module.exports = __webpack_public_path__ + "static/media/kredyt_33.94a668cb.png";